import { Product } from "@/ui-sdk/types";
import { PRODUCT_ITEM_HANDLE } from "./product-list";
import { HeliumSDK } from "@/sdk/helium";
import { createRoot } from "react-dom/client";
import React from "react";
export function parseHandles(handlesStr: string | null): string[] {
  if (!handlesStr) {
    return [];
  }
  try {
    const formattedHandlesStr = handlesStr
      .replace(/'/g, '"')
      .replace(/^\[|\]$/g, "");
    const validJsonStr = `[${formattedHandlesStr
      .split(",")
      .map((handle) => `"${handle.trim()}"`)
      .join(",")}]`;
    return JSON.parse(validJsonStr);
  } catch (error) {
    console.error("Error parsing handles:", error);
    return [];
  }
}

export function updateShopifyImage(img: string) {
  if (!img.includes("https:")) {
    return "https:" + img;
  } else {
    return img;
  }
}

export async function getProducts(handles: string[]) {
  try {
    return await Promise.all(
      handles.map(async (handle) => {
        const product = (
          await window.helium.datastore.getProduct({
            id: handle,
          })
        )?.details;
        return product;
      }),
    );
  } catch (e) {
    console.log("Error getting products", e);
    return [];
  }
}
function escapeRegex(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

type dataTypes = "title" | "price" | "compare-at-price" | "discount" | "image";
export function dataTypeCloneNode(
  templateNode: HTMLElement,
  product: Product,
  existingProduct: Product,
) {
  const clonedNode = templateNode.cloneNode(true) as HTMLElement;
  const dataElements = clonedNode.querySelectorAll(`[data-type]`);
  // clonedNode.querySelector("a")?.setAttribute("href", `/.asdasdasdasdasdasdas`);
  dataElements.forEach((element) => {
    const dataType = element.getAttribute("data-type") as dataTypes;
    switch (dataType) {
      case "title":
        console.log({ element: element.textContent, product: product.title });
        element.innerHTML = product.title;
        console.log({ element: element.textContent });
        break;
      case "price":
        element.textContent = `₹${Number(
          product?.priceRange?.maxVariantPrice?.amount ||
            product?.priceRange?.maxVariantPrice ||
            0,
        ).toFixed(0)}`;
        break;
      case "compare-at-price":
        element.textContent = `₹${Number(
          product?.compareAtPriceRange?.maxVariantPrice?.amount ||
            product?.compareAtPriceRange?.maxVariantPrice ||
            0,
        ).toFixed(0)}`;
        break;
      case "discount":
        element.textContent = product?.discount || "";
        break;
      case "image":
        element.setAttribute("src", product.image);

        const srcSet = element.getAttribute("srcset");
        if (srcSet) element.removeAttribute("srcset");
        break;
      case "link":
        console.log("sidkbahar");
        element.setAttribute("href", `/products/${product.handle}`);
        break;
    }
  });
  clonedNode.setAttribute("data-helium-name", "product-item");
  clonedNode.setAttribute(PRODUCT_ITEM_HANDLE, product.handle);
  clonedNode.id = product.handle;
  return clonedNode;
}

export function cloneNode(
  templateNode: HTMLElement,
  product: Product,
  existingProduct: Product,
  hasVariant?: boolean,
): HTMLElement {
  const clonedNode = templateNode.cloneNode(true) as HTMLElement;

  console.log({
    existingProduct,
    templateNode: templateNode.innerHTML,
    product,
  });

  if (clonedNode.querySelector("[data-type]")) {
    dataTypeCloneNode(templateNode, product, existingProduct);
  }

  //TODO : always add .amount
  const priceAmount = Number(
    product?.priceRange?.maxVariantPrice?.amount ||
      product?.priceRange?.maxVariantPrice ||
      0,
  ).toFixed(0);
  clonedNode.innerHTML = clonedNode.innerHTML
    .replace(
      new RegExp(
        `(${escapeRegex(existingProduct.title)})|(${existingProduct.handle})|(data-helium-listener="true")|(${existingProduct.id})`,
        "g",
      ),
      (match) => {
        if (match === existingProduct.title) return product.title;
        if (match === existingProduct.handle) return product.handle;
        if (match === existingProduct.id) return product.id;
        if (match === `data-helium-listener="true"`) return "";
      },
    )
    .replace(
      `${Number(existingProduct?.priceRange?.maxVariantPrice?.amount || 0).toLocaleString()}<`,
      `${Number(priceAmount).toLocaleString()}<`,
    );
  const dataElements = clonedNode.querySelectorAll(`[data-type]`);

  dataElements.forEach((element) => {
    const dataType = element.getAttribute("data-type") as dataTypes;
    switch (dataType) {
      case "title":
        console.log({
          element: element.textContent,
          product: product.title,
          element2: element,
        });
        element.innerHTML = product.title;
        break;
      case "price":
        element.textContent = `₹${Number(
          product?.priceRange?.maxVariantPrice?.amount ||
            product?.priceRange?.maxVariantPrice ||
            0,
        ).toFixed(0)}`;
        break;
      case "compare-at-price":
        element.textContent = `₹${Number(
          product?.compareAtPriceRange?.maxVariantPrice?.amount ||
            product?.compareAtPriceRange?.maxVariantPrice ||
            0,
        ).toFixed(0)}`;
        break;
      case "discount":
        element.textContent = product?.discount || "";
        break;
      case "image":
        element.setAttribute("src", product.image);
        const srcSet = element.getAttribute("srcset");
        if (srcSet) element.removeAttribute("srcset");
        break;
    }
  });

  if (window.helium.brandData.orgId === "culture-circle") {
    // if (window.location.pathname.includes("products")) {
    //   const price = clonedNode.querySelector("[class^='a_price'");
    //   price.innerHTML = `₹ ${Number(priceAmount).toLocaleString()}`;
    //   const title = clonedNode.querySelector("[class^='a_name'");
    //   title.innerHTML = product.title;
    // } else {
    const price =
      clonedNode.querySelector("[class='text-sm text-gray-900']") ??
      clonedNode.querySelector("[class^='a_price'");
    if (price) price.innerHTML = `₹ ${Number(priceAmount).toLocaleString()}`;
    // }
    // const title = clonedNode.querySelector("[class^='a_name'");
    // title.innerHTML = product.title;
  }
  const links = clonedNode.querySelectorAll("a");

  const isProductPage = window.location.pathname.includes("/products/");
  links.forEach((link) => {
    const currentHref = link.getAttribute("href");

    if (currentHref && currentHref.includes(`/${existingProduct.id}`)) {
      let newHref = currentHref.replace(
        `/${existingProduct.id}`,
        `/${product.id}`,
      );
      if (hasVariant) newHref = newHref + `?variant=${product.variantId}`;
      console.log({ newHref });
      link.setAttribute("href", newHref);
    }
    if (
      isProductPage &&
      (product?.priceRange?.maxVariantPrice?.currencyCode ||
        product?.["priceRange.maxVariantPrice.currencyCode"])
    ) {
      const currencyCode =
        product?.priceRange?.maxVariantPrice?.currencyCode ||
        product?.["priceRange.maxVariantPrice.currencyCode"];
      if (currencyCode === "INR") {
        clonedNode.innerHTML = clonedNode.innerHTML.replace(
          currencySymbol["USD"],
          currencySymbol["INR"],
        );
      } else {
        clonedNode.innerHTML = clonedNode.innerHTML.replace(
          currencySymbol["USD"],
          `${currencyCode} `,
        );
      }
    }
  });
  const imagesNode = clonedNode.querySelectorAll("img");
  imagesNode.forEach((img, i) => {
    if (hasVariant) {
      const variantImage = product?.variants?.find(
        (variant) => variant.id === product.variantId,
      )?.image.url;
      console.log({
        id: product.variantId,
        variants: product.variants,
        variantImage,
      });
      img.setAttribute("src", variantImage || product.variants[i].image.url);
      const srcSet = img.getAttribute("srcset");
      if (srcSet) img.removeAttribute("srcset");
      return;
    }
    if (product?.image) {
      img.setAttribute("src", product.image);
      const srcSet = img.getAttribute("srcset");
      if (srcSet) img.removeAttribute("srcset");
      return;
    }
    if (product?.images?.[i] == undefined) return;

    img.setAttribute(
      "src",
      product.images[i].url ? product.images[i].url : product.images[i],
    );
    const srcSet = img.getAttribute("srcset");
    if (srcSet) img.removeAttribute("srcset");
  });

  clonedNode.setAttribute("data-helium-name", "product-item");
  clonedNode.setAttribute(PRODUCT_ITEM_HANDLE, product.handle);
  clonedNode.id = product.handle;
  return clonedNode;
}

interface PollingOptions {
  checkFunction: () => boolean;
  interval?: number;
  timeout?: number;
  errorMessage?: string;
}

export const DEFAULT_POLLING_INTERVAL = 100;
export const DEFAULT_POLLING_TIMEOUT = 10000;

const currencySymbol = {
  USD: "$",
  INR: "₹",
};
export function poll({
  checkFunction,
  interval = DEFAULT_POLLING_INTERVAL,
  timeout = DEFAULT_POLLING_TIMEOUT,
  errorMessage = "Polling timed out",
}: PollingOptions): Promise<void> {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const check = () => {
      if (checkFunction()) {
        resolve();
      } else if (Date.now() - startTime > timeout) {
        reject(new Error(errorMessage));
      } else {
        setTimeout(check, interval);
      }
    };

    check();
  });
}

export const renderReact = (
  Component: React.ComponentType<any>,
  props: any,
  container: HTMLElement,
) => {
  const root = createRoot(container);
  root.render(React.createElement(Component, props));
  return root;
};

export function getOrgAndStoreId(orgId: string, storeId: string) {
  if (storeId === "no-id") {
    return orgId; // If storeId is empty or falsy, return only orgId
  } else if (!storeId) {
    return orgId;
  } else {
    return `${orgId}-${storeId}`; // Otherwise, return formatted string
  }
}
